import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {bg} from 'date-fns/locale'
import React, {Suspense} from 'react'
import {createRoot} from 'react-dom/client'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import {Provider} from 'react-redux'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import 'react-table/react-table.css'
import App from './components/App'
import {nls, nlss} from './components/nls'
import './i18n'
import {AuthProvider} from './contexts/JWTContext'
import {extendNls} from './core/components/nls'
import {InitConfig} from './core/config'
import './css/app'
import AuthGuard from './guards/AuthGuard'
import appConfig from './reducers/appConfig'
import {AppServiceHub} from './services/AppServiceHub'
import {PathsContextProvider} from './shared/paths-context-provider'

const NewLocality = React.lazy(() => import('./pages').then(m => ({default: m.NewLocality})))
const Archive = React.lazy(() => import('./pages/Archive/Archive'))

const rootContainer = document.getElementById('app') as HTMLDivElement
document.addEventListener('DOMContentLoaded', () => {
  if (rootContainer !== null) {
    const root = createRoot(rootContainer)
    root.render(
      <AuthProvider>
        <PathsContextProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={bg}>
            <BrowserRouter>
              <Suspense fallback={null}>
                <Routes>
                  <Route path="/" element={<LegacyApp />} />
                  <Route
                    path="new-locality"
                    element={
                      <AuthGuard>
                        <NewLocality />
                      </AuthGuard>
                    }
                  />
                  <Route
                    path="archive"
                    element={
                      <AuthGuard>
                        <Archive />
                      </AuthGuard>
                    }
                  />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </LocalizationProvider>
        </PathsContextProvider>
      </AuthProvider>
    )
  }
})

function LegacyApp() {
  const initConfig = new InitConfig()
  const store = initConfig.configureStore()
  AppServiceHub.initServices(appConfig, store)
  extendNls(nlss, nls)

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}
